import { MouseEvent, useEffect, useState } from 'react';
import { Image, ButtonBase, Text } from '@belong/ui';
import clsx from 'clsx';
import { useUpdateResidentFavorite } from 'src/features/residents';
import { useUser } from 'src/features/users/useUser';
import { useStore } from 'src/store';
import { popModalSelector, pushModalSelector } from 'src/store/modal';
import css from './favorite-button.module.css';

export function FavoriteButton({
  homeId,
  isFavorite,
  showLabel = false,
}: FavoriteButtonProps) {
  const { user } = useUser();
  const { userId } = user || {};
  const pushModal = useStore(pushModalSelector);
  const popModal = useStore(popModalSelector);
  const [isFavoriteState, setIsFavoriteState] = useState(isFavorite);
  const { updateFavorite } = useUpdateResidentFavorite();

  useEffect(() => {
    setIsFavoriteState(isFavorite);
  }, [isFavorite]);

  async function handleClick(e: MouseEvent<HTMLButtonElement>) {
    e.preventDefault();

    if (!userId) {
      return pushModal({
        type: 'LOGIN',
        props: {
          onSuccessfulLogin: async () => {
            await handleFavorite();
            popModal();
          },
        },
      });
    }

    handleFavorite();
  }

  async function handleFavorite() {
    setIsFavoriteState(!isFavoriteState);
    try {
      await updateFavorite({ homeId, isFavorite: !isFavoriteState });
    } catch {
      setIsFavoriteState(isFavoriteState);
    }
  }

  return (
    <ButtonBase onClick={handleClick} className="flex items-center">
      <div
        className={clsx(css.heartIcon, {
          [css.heartIconWithLabel!]: showLabel,
        })}
      >
        <Image
          src="icons/heart_icon.svg"
          alt=""
          className={clsx({ hidden: !isFavoriteState })}
        />
        <Image
          src="icons/post_icon_19.svg"
          alt=""
          className={clsx({ hidden: isFavoriteState })}
        />
      </div>
      {showLabel && (
        <Text fontWeight="semibold" className="ml-2xs">
          {isFavoriteState ? 'FAVORITED' : 'FAVORITE'}
        </Text>
      )}
    </ButtonBase>
  );
}

type FavoriteButtonProps = {
  isFavorite: boolean;
  homeId: string;
  showLabel?: boolean;
};
